import { ReactQuery } from '@codeleap/query'
import { BaseChatPackage } from '../utils'
import { useUser } from '../stores'

export const EXCLUDED_WORDS_QUERY_KEY = ['chat', 'excluded-words']

export class UseExcludedWords extends BaseChatPackage {
  useExcludedWords() {
    const user = useUser()
    return ReactQuery.useQuery({
      queryKey: EXCLUDED_WORDS_QUERY_KEY,
      queryFn: async () => {
        const response = await this.chatApi.fetchExcludedWords()
        if (response.ok && response.data) {
          return response.data.results.map((item: { word: string }) => item.word)
        }
        throw new Error('Failed to fetch excluded words')
      },
      enabled: !!user?.id,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000
    })
  }
}
